import React from "react";
import { CiCalendar } from "react-icons/ci";
import { FaRegStar, FaMagic } from "react-icons/fa";
import { TbClockHour4 } from "react-icons/tb";
import BookingButton from "./utilities/BookingButton";
import { Link } from "react-router-dom";

const benefits = [
  {
    icon: <CiCalendar size={24} />,
    title: "Réservation facile",
    description:
      "Prenez rendez-vous en ligne en quelques clics, 24h/24 et 7j/7.",
    link: "/services",
  },
  // {
  //     icon: <TbClockHour4 size={24} />,
  //     title: 'Gain de temps',
  //     description: "Arrivez à l'heure prévue, sans attente ni retard.",
  // },
  {
    icon: <FaMagic size={24} />,
    title: "Services premium",
    description: "Des prestations de qualité avec des produits haut de gamme.",
    link: "/services",
  },
  {
    icon: <FaRegStar size={24} />,
    title: "Fidélité récompensée",
    description:
      "Cumulez des points à chaque visite et bénéficiez d'avantages exclusifs.",
    link: "#",
  },
];

const FooterSection = () => {
  return (
    <section className="bg-[#f6f6f2] text-white py-12" id="contact">
      {/* Benefits Section */}
      <div className="w-full bg-[#1c1c1c] px-4 text-center">
        {/* <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 py-12"> */}
        <div className="max-w-7xl mx-auto flex md:flex-row flex-col justify-center gap-10 py-12">
          {benefits.map((benefit, index) => (
            <Link to={benefit.link} key={index}>
              <div className="flex flex-col items-center text-center px-4">
                <div className="mb-3 bg-gray-800 p-3 text-white">
                  {benefit.icon}
                </div>
                <h3 className="font-poppins font-semibold text-[18px] text-white">
                  {benefit.title}
                </h3>
                <p className="font-nunito text-[14px] text-gray-400 mt-2">
                  {benefit.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="w-full relative text-black text-center mt-8">
        <div className="absolute w-full h-full flex justify-center items-center pointer-events-none">
          <div className="w-52 h-52 bg-secondary-200/50 rounded-full blur-3xl" />
        </div>
        <div className="py-16 px-4 grid lg:grid-cols-12">
          <div className="md:col-span-6 2xl:col-span-4 md:col-start-4 2xl:col-start-5 text-center mx-auto max-w-2xl">
            <h2 className="font-poppins font-semibold text-[24px] md:text-[32px] text-[#222] mb-4">
              Prêt à vous faire plaisir ?
            </h2>
            <p className="font-nunito text-[14px] md:text-[16px] text-[#333] mb-6">
              Réservez dès maintenant et offrez-vous un moment de détente et de
              bien-être dans notre salon.
            </p>

            <div className="flex gap-3 items-center justify-center">
              <BookingButton label="Prendre rendez-vous" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterSection;